import styles from './Spinner.module.css'
import cx from 'classnames'
import { match } from '@/utils/pattern-match-util'

export interface SpinnerProps {
  size?: number
  thickness?: number
  variant?: SpinnerVariant
  testId?: string
}

export type SpinnerVariant = 'default' | 'invert' | 'inherit'

export function Spinner({
  variant = 'default',
  size = 24,
  testId,
}: SpinnerProps) {
  return (
    <div
      data-test={testId}
      className={cx(
        styles.root,
        match(variant, {
          default: styles.default,
          invert: styles.invert,
          inherit: styles.inherit,
        }),
      )}
      style={{
        width: size,
        height: size,
      }}
    >
      <svg
        className={styles.svg}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_4643_931)">
          <circle
            cx="12"
            cy="12"
            r="10.5"
            transform="rotate(-180 12 12)"
            strokeOpacity="0.24"
            strokeWidth="3"
          />
          <path
            d="M12 1.5C13.3789 1.5 14.7443 1.77159 16.0182 2.29926C17.2921 2.82694 18.4496 3.60036 19.4246 4.57538C20.3996 5.55039 21.1731 6.7079 21.7007 7.98182C22.2284 9.25574 22.5 10.6211 22.5 12"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_4643_931">
            <rect width="24" height="24" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
